import PropTypes from "prop-types";
import ProjectSpecifications from "./BenchmarkingProjectSpecifications";
import { generateProjectSchedules } from "./BenchmarkProjectSpecificationHelper";


/// props validation | SQ(javascript:S6774)
ProjectScheduleSpecifications.propTypes = {
  thisBenchmark: PropTypes.object,
  benchmarks: PropTypes.array,
  caller: PropTypes.string,
  moduleId: PropTypes.string,
  specificationInfo: PropTypes.string,
  specificatonsList: PropTypes.array,
};
export default function ProjectScheduleSpecifications(props) {
  const {
    thisBenchmark,
    benchmarks,
  } = props;

let updatedThisBenchmark = generateProjectSchedules(thisBenchmark);
let updatedBenchmarks = benchmarks.map((benchmark) => {
  return generateProjectSchedules(benchmark);});

  return <ProjectSpecifications benchmarks={updatedBenchmarks} thisBenchmark={updatedThisBenchmark} {...props} />;
}

